<template>
  <div>
    <v-container class="mt-8">
      <div class="text-right mt-3" v-if="1 == 2">
        <a @click="switchLan" class="btn ml-2" v-if="lan == 1">
          <i class="fas fa-globe-americas"></i> Français
        </a>
        <a @click="switchLan" class="btn ml-2" v-else>
          <i class="fas fa-globe-americas"></i> English
        </a>
      </div>

      <v-row>
        <v-col class="col-12 col-sm-5">
          
          <div style=" margin-bottom: 30px;">
            <v-btn
              style="min-width: 0px !important; margin: auto"
              @click="onCreate"
              color="primary"
              block
              >{{ $t("labels.CreateMortgageApplication") }}</v-btn
            >
          </div>

          <div style="margin-bottom: 20px;text-align: justify;">{{ $t("labels.CreateAnAccountOrSignIn") }}</div>
          <v-tabs centered v-model="tab" background-color="transparent" grow>
            <v-tabs-slider></v-tabs-slider>
            <v-tab>{{ $t("labels.SignIn") }}</v-tab>
            <!-- <v-tab>{{ $t("labels.CreateNewAccount") }}</v-tab>           -->
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <v-btn
                    @click="auth('google')"
                    color="black"
                    outlined
                    block
                    class="mb-2"
                    style="border-color: #d3d4d6"
                  >
                    <v-img
                      class="mr-3"
                      src="/images/google.png"
                      max-height="18"
                      max-width="18"
                    />
                    {{ $t("labels.SignInWithGoogle") }}
                  </v-btn>
                  <v-btn
                  v-if="1==2"
                    @click="auth('facebook')"
                    color="black"
                    outlined
                    block
                    style="border-color: #d3d4d6"
                  >
                    <v-img
                      class="mr-3"
                      src="/images/facebook.png"
                      max-height="18"
                      max-width="18"
                    />
                    {{ $t("labels.SignInWithFacebook") }}
                  </v-btn>
                </v-card-text>
                <div class="separator">{{ $t("labels.Or") }}</div>
                <v-card-text>
                  <v-text-field
                    placeholder=" "
                    :label="$t('labels.EmailR')"
                    required
                    v-model="signFrm.Email"
                    @keyup.enter="singIn"
                  />
                  <v-text-field
                  placeholder=" "
                    @keyup.enter="singIn"
                    :label="$t('labels.Password')"
                    type="password"
                    required
                    v-model="signFrm.Password"
                  />
                  <v-btn
                    @click="singIn"
                    color="primary"
                    block
                    :disabled="!isSignFrmValid"
                    >{{ $t("labels.SignIn") }}</v-btn
                  >
                  <v-btn @click="forgotPWD" text class="mt-4 floating-right">{{
                    $t("labels.ForgotPWD")
                  }}</v-btn>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card>
                <v-card-text>
                  <v-text-field
                    :label="$t('labels.FirstNameR')"
                    v-model="registerFrm.FirstName"
                  />
                  <v-text-field
                    :label="$t('labels.LastNameR')"
                    v-model="registerFrm.LastName"
                  />
                  <v-text-field
                    :label="$t('labels.EmailR')"
                    v-model="registerFrm.Email"
                  />
                  <v-text-field
                    :label="$t('labels.Password')"
                    type="password"
                    v-model="registerFrm.Password"
                  />
                  <v-text-field
                    :label="$t('labels.ConfirmPassword')"
                    v-model="registerFrm.ConfirmPassword"
                    type="password"
                    :error-messages="passwordError"
                    :error="passwordError != ''"
                  />
                  <div v-html="$t('labels.UserPasswordHint')" />
                  <p class="mt-3">
                    {{ $t("labels.TermsAndConditions_Part1") }}
                    <a @click="showTerms">{{
                      $t("labels.TermsAndConditions_Part2")
                    }}</a>
                    {{ $t("labels.TermsAndConditions_Part3") }}
                    <a @click="showPrivacy">{{
                      $t("labels.TermsAndConditions_Part4")
                    }}</a
                    >.
                  </p>

                  <v-btn
                    :disabled="!isRegisterFrmValid"
                    class="mt-8"
                    @click="registerUser"
                    color="primary"
                    block
                    >Create Account</v-btn
                  >
                </v-card-text>
              </v-card>
            </v-tab-item>          
          </v-tabs-items>
        </v-col>
        <v-col class="col-12 col-sm-7">
          <p_agent :pd="siteConf.Link" />
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t('labels.CreateMortgageApplication')}}</span>
        </v-card-title>
        <v-card-text>         
          <com_Email v-model="withoutLogin.Email" />        
          <v-btn
            :disabled="withoutLogin.Email == null || withoutLogin.Email == ''"
            @click="CreateMortgageApplication"
            color="primary"
            
            ><span v-if="!codeFlag">{{ $t("labels.Send")}}</span><span v-else>{{ $t("labels.Resend")}}</span></v-btn
          >
        </v-card-text>
        <v-card-text>
          <div v-html="$t('labels.ValidationEmailSent')" />
          <div class="d-flex" style="margin-top: 15px">           
            <com_six ref="sixdigit"  v-model="validateCode.code" />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogClose">{{
            $t("labels.Close")
          }}</v-btn>       
           <v-btn           
            @click="ClearCode"
            color="blue darken-1"   
            text         
            >{{ $t("labels.ClearCode")}}</v-btn
          >  
          <v-btn
            
            :disabled="validateCode.code == null"
            @click="VerifyCode"
            color="blue darken-1"   
            text         
            >{{ $t("labels.VerifyCode")}}</v-btn
          >
         
              
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="Verifydialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Verify Email</span>
        </v-card-title>       
        <v-card-text>
          <div v-html="$t('labels.ValidationEmailSent')" />
          <div class="d-flex" style="margin-top: 15px">           
            <com_six  v-model="registerFrm.code" />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>         
          <v-btn color="blue darken-1" text @click="VerifydialogClose">{{
            $t("labels.Close")
          }}</v-btn>          
          <v-btn          
            :disabled="registerFrm.code == null"
            @click="RegisterVerifyCode"
            color="blue darken-1"   
            text         
            >Verify Code</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="loading" v-if="loadFlag">Loading&#8230;</div>
  </div>
</template>

<script>
import localStorageSvc from "@/services/localStorage";
import p_agent from "./agentInfo";
import dataSvc from "@/services/dataService";
import { EventBus } from "@/services/eventBus";
import com_Email from "@/shared/components/emailHome";
import com_six from "@/shared/components/sixDigit";
export default {
  components: { p_agent, com_Email, com_six },
  data() {
    return {
      Verifydialog: false,
      dialog: false,
      codeFlag: false,
      validateCode: {
        Email: null,
        code: null,
        siteID: this.$route.params.siteid,
      },
      lan: 1,
      loadFlag: false,
      siteID: this.$route.params.siteid,
      tab: null,
      siteConf: {
        user: {},
        site: {},
      },
      signFrm: {
        Email: null,
        Password: null,
        SiteID: this.$route.params.siteid,
      },
      registerFrm: {
        Email: null,
        FirstName: null,
        LastName: null,
        Password: null,
        ConfirmPassword: null,
        SiteID: this.$route.params.siteid,
        code: null,
        LanguageID: 1
      },
      withoutLogin: {
        Email: null,
        SiteID: this.$route.params.siteid,
        LanguageID: 1
      },
    };
  },
  computed: {
    isSignFrmValid() {
      if (this.signFrm.Email && this.signFrm.Password) return true;
      return false;
    },
    isRegisterFrmValid() {
      if (
        this.registerFrm.FirstName &&
        this.registerFrm.LastName &&
        this.registerFrm.Email &&
        this.registerFrm.Password &&
        this.passwordError == ""
      ) {
        if (this.registerFrm.Password.length >= 6) return true;
      }

      return false;
    },
    passwordHint() {
      if (this.registerFrm.Password) {
        if (this.registerFrm.Password == "") return "";
        if (this.registerFrm.Password.length < 6)
          return this.$t("labels.PasswordHint");
      }
      return "";
    },
    passwordError() {
      if (this.registerFrm.ConfirmPassword) {
        if (this.registerFrm.ConfirmPassword != this.registerFrm.Password) {
          return this.$t("labels.ConfirmPasswordNotMatch");
        }
      }
      return "";
    },
  },
  methods: {
    VerifydialogClose(){
      this.Verifydialog = false;
    },
    dialogClose() {
      this.dialog = false;
    },
    onCreate() {
      this.codeFlag = false;
      this.dialog = true;
      this.withoutLogin.Email = null;
    },
    singIn() {
      if (this.signFrm.Email && this.signFrm.Password) {
        this.loadFlag = true;
        dataSvc
          .getHttp()
          .post("/api/MTGAPPUserSignIn", this.signFrm)
          .then((res) => {
            this.loadFlag = false;
            if (res.data.ReturnStatus.ReturnCode == 200) {
              localStorageSvc.setUser(res.data.UserID);
              EventBus.$emit("usersignin");
              this.$router.push("/" + this.siteID + "/user/mydeals");
            } else {
              if(res.data.ReturnStatus.ReturnMessage == "EmailNotRegistered"){

                 let msg = this.$t("errors." + res.data.ReturnStatus.ReturnMessage);
                  msg = msg.replace("0", this.signFrm.Email);
                  this.$alert(
                this.$t("labels.Warning"),
                msg
              );
              }else{
                this.$alert(
                this.$t("labels.Warning"),
                this.$t("errors." + res.data.ReturnStatus.ReturnMessage)
              );
              }
              
            }
          })
          .catch((err) => {
            console.dir(err);
            this.loadFlag = false;
          });
      } else {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("errors.EmailPasswordRequired")
        );
      }
    },
    forgotPWD() {
      this.$prompt(
        this.$t("labels.ForgotPWD"),
        this.$t("labels.ForgotPWD_EnterYourPassword"),
        "",
        (evt, v) => {
          if (evt && v) {
            this.loadFlag = true;
            let postData = {
              SiteID: this.siteID,
              Email: v,
            };
            this.loadFlag = true;
            dataSvc
              .getHttp()
              .post("/api/MTGAPPUserForgotPassword", postData)
              .then((res) => {
                this.loadFlag = false;
                if (res.data.ReturnStatus.ReturnCode == 200) {
                  this.$alert(
                    this.$t("labels.ForgotPWD"),
                    this.$t("labels.ForgotPasswordSent")
                  );
                } else {
                  this.$alert(
                    this.$t("labels.Warning"),
                    this.$t("errors." + res.data.ReturnStatus.ReturnMessage)
                  );
                }
              });
          }
        },
        () => {}
      );
    },
    showTerms() {
      EventBus.$emit("showterm");
    },
    showPrivacy() {
      EventBus.$emit("showprivacy");
    },
    ClearCode(){
      this.validateCode.code = null;
      this.$refs.sixdigit.Verifyclear();
    },
    VerifyCode() {
      this.validateCode.Email = this.withoutLogin.Email;
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/MTGAPPVerifyCode", this.validateCode)
        .then((res) => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            localStorageSvc.setUser(res.data.UserID);
            EventBus.$emit("usersignin");
            this.$router.push("/" + this.siteID + "/user/mydeals");
          } else {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("errors." + res.data.ReturnStatus.ReturnMessage)
            );
          }
        });
    },
     RegisterVerifyCode() {
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/MTGAPPRegisterVerifyCode", this.registerFrm)
        .then((res) => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            localStorageSvc.setUser(res.data.UserID);
            EventBus.$emit("usersignin");
            this.$router.push("/" + this.siteID + "/user/mydeals");
          } else {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("errors." + res.data.ReturnStatus.ReturnMessage)
            );
          }
        });
    },
    CreateMortgageApplication() {
      this.loadFlag = true;
    let lan  = localStorageSvc.getLan();
      if(lan == "fr" || lan == "FR"){
         this.withoutLogin.LanguageID = 2;
      }else{
         this.withoutLogin.LanguageID = 1
      }    
      dataSvc
        .getHttp()
        .post("/api/MTGAPPValidateEmail", this.withoutLogin)
        .then((res) => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.codeFlag = true;
          } else {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("errors." + res.data.ReturnStatus.ReturnMessage)
            );
          }
        });
    },
    registerUser() {
      this.loadFlag = true;
      let lan  = localStorageSvc.getLan();
      if(lan == "fr" || lan == "FR"){
         this.registerFrm.LanguageID  = 2;
      }else{
         this.registerFrm.LanguageID  = 1
      }     
      dataSvc
        .getHttp()
        .post("/api/MTGAPPRegisterUser", this.registerFrm)
        .then((res) => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.Verifydialog = true;
            this.VerifyCode.code = null;            
          } else {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("errors." + res.data.ReturnStatus.ReturnMessage)
            );
          }
        });
    },
    switchLan() {},
    auth(network) {
      const hello = this.hello;

      if (network == "facebook") {
        hello.init(
          {
            facebook: process.env.VUE_APP_FACEBOOK_AUTH_KEY,
          },
          {
            redirect_uri: "/mtgappauth",
            scope: "email",
          }
        );
      }
      if (network == "google") {
        hello.init(
          {
            google: process.env.VUE_APP_GOOGLE_AUTH_KEY,
          },
          {
            redirect_uri: "/mtgappauth",
            scope: "email,profile",
          }
        );
      }

      var me = this;
      hello(network)
        .login()
        .then(() => {
          hello(network)
            .api("me")
            .then(function (json) {
              me.registerOrLogin(json, network);
            });
        });
    },
    registerOrLogin(profile, network) {
      let postData = {
        NetWork: network,
        Email: profile.email,
        FirstName: profile.first_name,
        LastName: profile.last_name,
        SiteID: this.siteID,
      };
      if (network == "facebook") postData.Email = profile.id;

      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/MTGAPPRegisterUserOrLogin", postData)
        .then((res) => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            let userID = res.data.UserID;
            localStorageSvc.setUser(userID);
            EventBus.$emit("usersignin");
            this.$router.push("/" + this.siteID + "/user/mydeals");
          }
        });
    },
    loadPage() {
      this.loadFlag = true;
      dataSvc
        .getSiteConf(this.siteID)
        .then((res) => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {  
            if(res.data.newVersion == true){
              window.location.href = res.data.newVersionUrl;
              return;
            }       
            if (res.data.User != null) {
              this.$router.push("/" + this.siteID + "/user/mydeals");
              return;
            }
            this.siteConf = res.data;
            this.signFrm.Email = null;
           this.signFrm.Password = null;
            // var item = document.getElementById("SignINBtn");
            // item.click();
          } else {
            this.$router.push("/");
          }
        })
        .catch(() => {
          this.$router.push("/");
        });
    },
  },
  created() {
    let u = localStorageSvc.getUser();
    if (u) {
      this.$router.push("./user/mydeals");
    } else {      
      setTimeout(() => {
        this.loadPage();
      }, 200);
    }
  },
};
</script>

<style scoped>
.separator {
  display: flex;
  align-items: center;
  text-align: center;
}
.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #a0a0a0;
}
.separator::before {
  margin-right: 0.25em;
}
.separator::after {
  margin-left: 0.25em;
}
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #000000da;
}

.modal {
  text-align: center;
  background-color: white;
  height: 300px;
  width: 500px;
  margin-top: 10%;
  padding: 60px 0;
  border-radius: 20px;
}
</style>